module.exports = __webpack_public_path__ + "48b8cb615f1b3a495e81387b26f0df1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/imgs/Bip.svg
// module id = 256
// module chunks = 1